import clsx from "clsx";
import { FunctionComponent, isValidElement } from "react";

import { useComponentConfig } from "@ui/context/component-config-context";
import useDefaults from "@ui/hooks/use-defaults";

import Category, { type MetaCategoryBaseConfig } from "./Category";
import * as styles from "./Category.css";

interface category {
  category: string;
  path: string;
}

export interface CategoryListProps extends Partial<MetaCategoryBaseConfig> {
  categories: category[];
  superCats?: category[];
  componentContext?: string;
  variant?: keyof typeof styles.categoryList;
  className?: string;
}

const CategoryList: FunctionComponent<CategoryListProps> = (props) => {
  const {
    categories,
    superCats = [],
    componentContext,
    variant = "standard",
    className,
  } = props;
  const metaCategoryConfig = useComponentConfig(
    "metaCategory",
    componentContext || "",
  );

  const {
    categorySeparator = " /",
    metaVariation = "standard",
    showSuperCats = false,
    vertical,
  } = useDefaults(props, metaCategoryConfig);

  // Extract the separator, which could be a string, React element, or blank
  const separator =
    typeof categorySeparator === "string" && !!categorySeparator.length ? (
      <span className={clsx(styles.separator, styles.container[metaVariation])}>
        {categorySeparator}
      </span>
    ) : isValidElement(categorySeparator) ? (
      categorySeparator
    ) : null;

  const displayCategories = showSuperCats
    ? [...categories, ...superCats]
    : categories;

  return (
    <ul className={clsx(styles.categoryList[variant], className)}>
      {displayCategories.map((category, idx) => (
        <li
          key={idx}
          className={clsx(
            metaVariation === "linkButton" && styles.linkButtonListItem,
          )}
        >
          <Category
            {...category}
            vertical={vertical}
            metaVariation={metaVariation}
            componentContext={componentContext}
          />
          {idx < displayCategories.length - 1 && separator}
        </li>
      ))}
    </ul>
  );
};

export default CategoryList;
